/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseEmailForwarding
 */
export interface GetIntegrationsConfig200ResponseEmailForwarding {
    /**
     * 
     */
    targetMailbox: string;
    /**
     * 
     */
    redirectServiceProviderNotifications: boolean;
    /**
     * 
     */
    redirectClientNotifications: boolean;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseEmailForwarding interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseEmailForwarding(value: object): value is GetIntegrationsConfig200ResponseEmailForwarding {
    if (!('targetMailbox' in value) || value['targetMailbox'] === undefined) return false;
    if (!('redirectServiceProviderNotifications' in value) || value['redirectServiceProviderNotifications'] === undefined) return false;
    if (!('redirectClientNotifications' in value) || value['redirectClientNotifications'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseEmailForwardingFromJSON(json: any): GetIntegrationsConfig200ResponseEmailForwarding {
    return GetIntegrationsConfig200ResponseEmailForwardingFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseEmailForwardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseEmailForwarding {
    if (json == null) {
        return json;
    }
    return {
        
        'targetMailbox': json['targetMailbox'],
        'redirectServiceProviderNotifications': json['redirectServiceProviderNotifications'],
        'redirectClientNotifications': json['redirectClientNotifications'],
    };
}

export function GetIntegrationsConfig200ResponseEmailForwardingToJSON(json: any): GetIntegrationsConfig200ResponseEmailForwarding {
    return GetIntegrationsConfig200ResponseEmailForwardingToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseEmailForwardingToJSONTyped(value?: GetIntegrationsConfig200ResponseEmailForwarding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetMailbox': value['targetMailbox'],
        'redirectServiceProviderNotifications': value['redirectServiceProviderNotifications'],
        'redirectClientNotifications': value['redirectClientNotifications'],
    };
}

